<div class="store" *ngIf="heroContent$ | async as heroContent; else loading">
	<clearcals-store-header [heroContent$]="heroContent$"></clearcals-store-header>

	<div class="main">
		<div class="container">
			<clearcals-product-collection [products$]="products$"></clearcals-product-collection>
		</div>

                <clearcals-store-faq [pageContent$]="pageContent$"></clearcals-store-faq>
        </div>
</div>

<ng-template #loading>
	<div class="spinner">
		<mat-spinner diameter="50"></mat-spinner>
	</div>
</ng-template>